import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Text } from "@zorni/components-lib";

import styles from "./EstablishmentsLoadError.module.css";

/**
 * Affiché quand la liste des établissements (AdminProvider) n'a pas pu être
 * chargée. Volontairement distinct de AccountActivationRequired : cet écran
 * prétend que des étapes sont à faire, ce qui serait faux (et bloquant) pour un
 * utilisateur légitime touché par un simple incident réseau.
 */
const EstablishmentsLoadError = ({ onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root} role="alert">
      <span className={styles.icon}>
        <Icon name="iconWarning" size="lg" color="inherit" />
      </span>
      <Text as="h3" size="lg" weight="bold">
        {t("establishmentsLoadError.title", "Impossible de charger vos établissements")}
      </Text>
      <Text as="p" size="sm" color="muted">
        {t(
          "establishmentsLoadError.description",
          "Une erreur est survenue lors de la récupération de vos établissements. Vérifiez votre connexion puis réessayez."
        )}
      </Text>
      <Button
        variant="primary"
        label={t("establishmentsLoadError.retry", "Réessayer")}
        onClick={onRetry}
      />
    </div>
  );
};

export default EstablishmentsLoadError;
